export default __webpack_public_path__ + "static/media/3.53456d63.jpg";